module.exports = __webpack_public_path__ + "img/about-grid-02.2700d8b4.jpg";